/**
 * Optimizer constants shared by both looks (v1.70): the sportsbook filter
 * chips (by tier), the profit-boost options (beta, not wired yet) and the
 * Cloud Functions base URLs used by hooks/useOptimizerForm.js.
 */
import { Platform } from 'react-native';

export const ALL_SPORTSBOOKS = [
    { name: 'DraftKings', tier: 1, popular: true }, { name: 'FanDuel', tier: 1, popular: true }, { name: 'BetMGM', tier: 1, popular: true },
    { name: 'Caesars', tier: 1, popular: true }, { name: 'ESPNBet', tier: 1, popular: true }, { name: 'Fanatics', tier: 1, popular: true },
    { name: 'Bet365', tier: 1, popular: true },
    { name: 'BetRivers', tier: 2 }, { name: 'PointsBet', tier: 2 }, { name: 'Hard Rock', tier: 2 }, { name: 'WynnBET', tier: 2 },
    { name: 'Unibet', tier: 2 }, { name: 'Betfred', tier: 2 }, { name: 'SuperBook', tier: 2 }, { name: 'Tipico', tier: 2 },
    { name: 'BetParx', tier: 2 }, { name: 'Borgata', tier: 2 }, { name: 'Golden Nugget', tier: 2 }, { name: 'Bally Bet', tier: 2 },
    { name: 'Circa Sports', tier: 2 }, { name: 'Station Casinos', tier: 2 }, { name: 'Betway', tier: 2 }, { name: 'SI Sportsbook', tier: 2 },
    { name: 'Bovada', tier: 3 }, { name: 'BetOnline', tier: 3 }, { name: 'MyBookie', tier: 3 }, { name: 'BetUS', tier: 3 },
    { name: 'Pinnacle', tier: 3 }, { name: 'Bookmaker', tier: 3 }, { name: 'Heritage Sports', tier: 3 }, { name: 'BetAnySports', tier: 3 },
    { name: 'Jazz Sports', tier: 3 }, { name: 'Sportsbetting.ag', tier: 3 }, { name: 'GTBets', tier: 3 }, { name: 'Everygame', tier: 3 },
    { name: 'Xbet', tier: 3 }, { name: 'BetNow', tier: 3 }, { name: 'Nitrogen', tier: 3 }, { name: '5Dimes', tier: 3 }, { name: 'Intertops', tier: 3 },
    { name: 'PrizePicks', tier: 4 }, { name: 'Underdog', tier: 4 }, { name: 'Sleeper', tier: 4 }, { name: 'Fliff', tier: 4 },
    { name: 'Betr', tier: 4 }, { name: 'Novig', tier: 4 }, { name: 'ProphetX', tier: 4 }, { name: 'Thrive Fantasy', tier: 4 },
    { name: 'Monkey Knife Fight', tier: 4 }, { name: 'Dabble', tier: 4 },
];

export const POPULAR_SPORTSBOOKS = ALL_SPORTSBOOKS.filter((b) => b.popular).map((b) => b.name);

export const BOOST_OPTIONS = [
    { value: '0', label: 'No Boost' }, { value: '5', label: '5%' }, { value: '10', label: '10%' }, { value: '15', label: '15%' },
    { value: '20', label: '20%' }, { value: '25', label: '25%' }, { value: '30', label: '30%' }, { value: '35', label: '35%' },
    { value: '40', label: '40%' }, { value: '45', label: '45%' }, { value: '50', label: '50%' }, { value: '75', label: '75%' },
    { value: '100', label: '100%' },
];

// Player data lives in prod Firestore, not the local emulator.
export const PROD_URL = 'https://us-central1-bet-optimized-fe922.cloudfunctions.net';

export const getFunctionsBaseUrl = () => {
    if (Platform.OS === 'web') {
        const isLocalDev = window.location.hostname === 'localhost' ||
                          window.location.hostname === '127.0.0.1' ||
                          window.location.port === '19006';
        return isLocalDev ? 'http://127.0.0.1:5001/bet-optimized-fe922/us-central1' : PROD_URL;
    }
    return PROD_URL;
};
